import React from 'react';
import styled from 'styled-components';
import { getSize, Breakpoints, } from '../../DesignSystem/design-system';
const Container = styled.div `
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  align-items: ${(props) => props.align || 'flex-start'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  ${(props) => props.gap && `gap: ${getSize(props.gap)};`}
  ${(props) => props.fluid && `width: 100%;`}
  ${(props) => props.fluid && `height: 100%;`}
  ${(props) => props._isVisible && 'background-color: #ccc;'}
  ${(props) => props.flexWrap && 'flex-wrap: wrap;'}

  @media (max-width: ${Breakpoints.Mobile}) {
    ${(props) => props.mobileDirection && `flex-direction: ${props.mobileDirection};`}
    ${(props) => props.mobileAlign && `align-items: ${props.mobileAlign};`}
    ${(props) => props.mobileJustify && `justify-content: ${props.mobileJustify};`}
    ${(props) => props.mobileGap && `gap: ${getSize(props.mobileGap)};`}
  }
`;
/**
 * A flexible container component with various customization options.
 *
 * @param _isVisible - If true, the flex container will be visible (only for testing purposes).
 * @param {React.ReactNode} props.children - The child components that ImpFlex will contain.
 * @param {size} [props.gap] - The size of the gap between flex items. The size property is defined in our design system.
 * @param {string} [props.align='flex-start'] - The alignment of flex items along the cross axis. Corresponds to the align-items CSS property.
 * @param {string} [props.justify='flex-start'] - The alignment of flex items along the main axis. Corresponds to the justify-content CSS property.
 * @param {direction} [props.direction='row'] - The direction of flex items. Corresponds to the flex-direction CSS property.
 * @param {boolean} [props.fluid=false] - If true, the flex container will take up the full available width and height.
 * @param {string} [props.dataTestId='flex-container'] - The data-testid of the flex container.
 * @param {boolean} [props._isVisible=false] - If true, the flex container will have a background color to make it visible.
 *
 * @returns The ImpFlex component.
 */
export default function ImpFlex({ children, gap, align = 'flex-start', justify = 'flex-start', direction = 'row', fluid = false, dataTestId = 'flex-container', flexWrap = false, mobileAlign, mobileDirection, mobileGap, mobileJustify, _isVisible = false, ...args }) {
    return (React.createElement(Container, { gap: gap, align: align, justify: justify, direction: direction, fluid: fluid, _isVisible: _isVisible, "data-testid": dataTestId, mobileAlign: mobileAlign, mobileDirection: mobileDirection, mobileGap: mobileGap, mobileJustify: mobileJustify, flexWrap: flexWrap, ...args }, children));
}
//# sourceMappingURL=ImpFlex.js.map